import React, { useState } from "react";
import { Blurhash } from "react-blurhash";

const ResponsiveImage = ({ src, alt, className, hash }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`responsive-image-wrapper ${className}`}>
      {!loaded && (
        <Blurhash
          hash={hash}
          width="100%"
          height="300px"
          resolutionX={32}
          resolutionY={32}
          punch={1}
        />
      )}
      <img
        src={src}
        alt={alt}
        className={`responsive-image ${loaded ? "visible" : "hidden"}`}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default ResponsiveImage;
